export default __webpack_public_path__ + "static/media/Nirali.291938a9.jpeg";